import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PhxBaseDetailSaveButtonComponent } from "../../../components/phx-base-detail-save-button/phx-base-detail-save-button.component";
import { BlockableDiv } from "../../../controls/blockable-div/blockable-div.component";
import { WidgetSetRoleToUserComponent } from "./widget-set-role-to-user.component";

@Component({
  selector: 'app-formly-set-role-to-user',
  imports: [
    BlockableDiv,
    WidgetSetRoleToUserComponent,
    PhxBaseDetailSaveButtonComponent,
    TranslatePipe
  ],
  template: `
    <blockable-div [blocked]="!model?.id" [blockUi]="blockUi">
      @defer (when model?.id) {
          <app-widget-set-role-to-user
            #widgetSetRoleToUser
            [selectedUser]="model"
            [showUserDropdown]="false"
          />
        }
    </blockable-div>

    <ng-template #blockUi>
        <app-phx-base-detail-save-button
          [baseDetailComponent]="formState.detailComponent"
          [saveButtonLabel]="'common.save' | translate"
        />
    </ng-template>
  `,
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlySetRoleToUserComponent extends FieldType<FieldTypeConfig> { }
